import { SupportedLanguage } from '@/services/ai-translation/type/ai-translation.enum';

export interface ApiTechTopicRequest {
    input: string;
    source_lang: SupportedLanguage | null;
    target_lang: SupportedLanguage | null;
    task_id: string;
    current_step: string;
}

export interface ApiTechTopicResponse {
    original: string[];
    translation: string;
    percentage: number;
}

export const GetSuggestions = Symbol('GetSuggestions');

export interface GetSuggestions {
    getSuggestions(data: ApiTechTopicRequest): Promise<ApiTechTopicResponse[]>;
}